import MDBox from "components/MDBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import React, { useLayoutEffect } from "react";
import "./PrivacyPage.css";

const TermsNPrivacy = () => {
    useLayoutEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          const sectionId = hash.replace('#', '');
          const sectionElement = document.getElementById(sectionId);
          if (sectionElement) {
            // Smooth scroll to the section
            sectionElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, []);

  return (
    <PageLayout>
      <MDBox px={1} width="100%" height="100vh" mx="auto" className="privacy-container">
        {/* Terms & Conditions Section */}
        <section id="terms">
          <h1>Terms & Conditions</h1>
          <p>Effective as of 14th November, 2024</p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By using the Weddz platform, you agree to comply with and be bound by these Terms &
            Conditions. If you do not agree to these terms, please do not use the platform.
          </p>

          <h2>2. User Responsibilities</h2>
          <p>
            You are responsible for maintaining the accuracy of your profile information and for
            ensuring that your use of the platform complies with all applicable laws and
            regulations. You must not misuse the platform or engage in any harmful or fraudulent
            activities.
          </p>

          <h2>3. Subscription Services</h2>
          <p>
            Weddz offers subscription services for enhanced features and better profile visibility.
            By subscribing, you agree to pay the applicable fees and authorize us to charge your
            payment method through secure payment gateways.
          </p>

          <h2>4. Messaging and Communication</h2>
          <p>
            The platform provides a messaging system for users to communicate with potential
            matches. You are solely responsible for the content of your messages and interactions
            with other users. Weddz is not liable for any disputes or issues arising from user
            communications.
          </p>

          <h2>5. Termination of Account</h2>
          <p>
            Weddz reserves the right to suspend or terminate your account if you violate these Terms
            & Conditions or engage in any prohibited activities. You may also close your account at
            any time through your account settings.
          </p>

          <h2>6. Limitation of Liability</h2>
          <p>
            Weddz is not liable for any indirect, incidental, or consequential damages arising from
            your use of the platform. Our liability is limited to the maximum extent permitted by
            law.
          </p>

          <h2>7. Changes to Terms & Conditions</h2>
          <p>
            We may update these Terms & Conditions from time to time. Any changes will be posted on
            this page, and your continued use of the platform constitutes acceptance of the updated
            terms.
          </p>
        </section>

        {/* Privacy Policy Section */}
        <br></br>
        <section id="privacy">
          <h1>Privacy Policy</h1>
          <p>Effective as of 14th November, 2024</p>

          <p>
            Your privacy is important to us. At Weddz, we are committed to protecting your personal
            information and ensuring that it is used in ways that you agree to and understand.
          </p>

          <h2>1. Why does Weddz collect personal information?</h2>
          <p>
            We collect your personal information to provide you with a seamless and secure
            experience on our platform. This includes creating and managing your profile,
            facilitating matchmaking based on your preferences, enabling communication with
            potential matches, and offering subscription services for enhanced features.
          </p>

          <h2>2. What information does Weddz collect?</h2>
          <p>
            To offer you our services, we collect basic personal information such as your name,
            email address, phone number, date of birth, location, and preferences for matchmaking.
            You may also upload photos and provide additional details to enhance your profile. For
            subscription services, we collect payment information through secure payment gateways.
          </p>

          <h2>3. Does Weddz disclose your personal information to anyone?</h2>
          <p>
            We take your privacy seriously and do not share your personal information with third
            parties without your consent, except in the following circumstances:
          </p>
          <ul>
            <li>To facilitate matchmaking and display profiles based on user preferences.</li>
            <li>To process payments through secure payment gateways.</li>
            <li>
              To comply with legal obligations or respond to lawful requests from authorities.
            </li>
            <li>To protect the rights, property, or safety of Weddz, our users, or the public.</li>
          </ul>

          <h2>4. How does Weddz protect your personal information?</h2>
          <p>
            We implement appropriate technical, administrative, and physical measures to safeguard
            your personal information against unauthorized access, disclosure, alteration, or
            destruction. This includes encryption, secure payment gateways, and restricted access to
            your data.
          </p>

          <h2>5. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to enhance your experience on our platform.
            Cookies help us remember your preferences, analyze platform usage, and improve our
            services. You can manage or disable cookies through your browser settings, but this may
            affect certain features of the platform.
          </p>

          <h2>6. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices
            or legal requirements. We will notify you of significant changes by posting a notice on
            our platform or sending you an email. Your continued use of the platform after such
            changes constitutes your acceptance of the updated Privacy Policy.
          </p>

          <h2>7. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy or our data practices,
            please contact us at <a href="mailto:support@weddz.com">support@weddz.com</a>.
          </p>
        </section>
      </MDBox>
    </PageLayout>
  );
};

export default TermsNPrivacy;
